const ShippingMethodService = function () {
	return {
		methods: [],
		/**
		 * @param {ShippingMethod[]} methods
		 * @returns {ShippingMethodService}
		 */
		setMethods: function (methods) {
			this.methods = methods;
			return this;
		},

		/**
		 * Matrix of WLEC-6499 reduced to minimum
		 *
		 * @see http://jira.wlec.ag:20304/browse/WLEC-6499
		 *
		 * @param {ShippingMethod} item
		 * @param {Cart} Cart
		 * @return (number)
		 */
		getPrice: function (item, Cart) {
			if (item) {
				var ticketCost = Cart.ticketFormat !== null ? Cart.ticketFormat.shippingcosts * 1 : 0;

				return ticketCost + item.expenses * 1;
			} else {
				return 0;
			}
		},

		getShippingMethodByID: function (id) {
			id = parseInt(id);
			for (var k in this.methods) {
				if (!this.methods.hasOwnProperty(k)) {
					continue;
				}
				var shippingMethod = this.methods[ k ];
				if (parseInt(shippingMethod.id) === id) {
					return shippingMethod;
				}
			}
			return undefined;
		},

		validate: function (shippingMethod) {
			if (!shippingMethod || !shippingMethod.id) {
				return false;
			}

			for (var key in this.methods) {
				if (!this.methods.hasOwnProperty(key)) {
					continue;
				}

				if (parseInt(this.methods[ key ].id) === parseInt(shippingMethod.id)) {
					return true;
				}
			}
			return false;
		}
	};
};

export default ShippingMethodService;
